import React, { Component } from 'react';
import Front from './Front';

export default class Flipper extends Component {
  switchModal(item) {
    this.props.switchModal(item);
  }
  flip() {
    this.props.flip();
  }

  openNutritionInfo() {
    this.props.openNutritionInfo();
  }

  render() {
    return (
      <div className={'flipper-container ' + this.props.orientation}>
        <div className={'flipper' + (this.props.flipped ? ' flipped' : '')}>
          <Front
            flip={() => this.flip()}
            switchModal={clickedItem => this.switchModal(clickedItem)}
            item={this.props.item}
            openNutritionInfo={() => this.openNutritionInfo()}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/Flipper.jsx